import API from 'constants/API';

import {AxiosResponse} from 'axios';
import {CreateBeerDTO, GetBeersDTO} from 'typescript/dto/beersDto';
import {GetBeerPubsDTO} from 'typescript/dto/GetBeerPubsDTO';
import ApiData from 'typescript/interfaces/ApiData';
import {Beer, IBeerSocialMediaStatistic} from 'typescript/models/Beer';
import PubPage from 'typescript/models/PubPage';
import {StatisticDateRangeType} from 'typescript/types/StatisticDateRangeType';
import getOptionalParams from 'utils/helpers/getOptionalParams';
import {queryBuilder} from 'utils/helpers/queryBuilder';
import httpClient from 'utils/httpClient/httpClient';

export const getBeersList = (search: GetBeersDTO): Promise<AxiosResponse<ApiData<Beer[]>>> => {
  const {perPage, beerStyles, name, page} = search;

  const queryValues = getOptionalParams({search});

  const baseQuery = queryBuilder({
    baseQuery: `${API.BEERS_SERVICE.BASE}?`,
    queryObject: {page, per_page: perPage, 'filter[query_array]': name},
  });

  let optionalQueryParams = '';
  if (Object.keys(queryValues).length > 0) {
    optionalQueryParams = queryBuilder({
      baseQuery,
      queryObject: queryValues,
    });
  }

  if (beerStyles) optionalQueryParams += beerStyles;

  return httpClient.get(optionalQueryParams || baseQuery);
};

export const getSingleBeerData = (id: string): Promise<AxiosResponse<ApiData<Beer>>> => {
  return httpClient.get(`${API.BEERS_SERVICE.BASE}/${id}`);
};

export const createNewBeer = (newBeer: CreateBeerDTO): Promise<AxiosResponse<ApiData<Beer>>> => {
  const data = {beer: newBeer};

  return httpClient.post(API.BEERS_SERVICE.BASE, data);
};

export const updateBeerData = (id: string, updatedBeer: CreateBeerDTO): Promise<AxiosResponse<ApiData<Beer>>> => {
  const data = {beer: updatedBeer};

  return httpClient.put(`${API.BEERS_SERVICE.BASE}/${id}`, data);
};

export const getBeerPubs = (dto: GetBeerPubsDTO): Promise<AxiosResponse<ApiData<PubPage[]>>> => {
  const {page, id, column, direction} = dto;

  const baseQuery = queryBuilder({
    baseQuery: `${API.BEERS_SERVICE.BASE}/${id}/pubs?`,
    queryObject: {page, per_page: 10, 'filter[query_array]': ''},
  });

  let optionalQueryParams = '';
  if (column && direction) {
    optionalQueryParams = queryBuilder({
      baseQuery,
      queryObject: {'filter_sort[sort_column]': column, 'filter_sort[sort_direction]': direction},
    });
  }

  return httpClient.get(optionalQueryParams || baseQuery);
};

export const deleteBeer = (dto: {id: string}): Promise<AxiosResponse<ApiData<{}>>> => {
  return httpClient.delete(`${API.BEERS_SERVICE.BASE}/${dto.id}`);
};

export const getTopBeers = (): Promise<AxiosResponse<ApiData<Beer[]>>> => {
  return httpClient.get(`${API.BEERS_SERVICE.TOP_BEERS}`);
};

export const getBeerSocialMediaStatistic = (dto: {
  dateRange: StatisticDateRangeType;
  id: string;
}): Promise<AxiosResponse<ApiData<IBeerSocialMediaStatistic>>> => {
  const query = queryBuilder({
    baseQuery: `${API.BEERS_SERVICE.BASE}/${dto.id}?`,
    queryObject: {'filter_statistic[date_range]': dto.dateRange},
  });

  return httpClient.get(query);
};
